module.exports = __webpack_public_path__ + "img/Component 3.0414efb8.svg";